import {ReactElement} from "react"

const LeftIcon = (): ReactElement => {
	return (
		<svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M9 17L1 9L9 1"
				stroke="#7E8591"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}

export default LeftIcon
